import {NAME} from './constants';

export const isFilterOpen = state => state[NAME].filterOpen;
export const isInputFocused = state => state[NAME].inputFocus;
export const isPristine = state => state[NAME].pristine;


/** WEBPACK FOOTER **
 ** ./src/modules/search/selectors.js
 **/